import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const rejectTimeOffHr = async (
	port: TimeOffPort,
	id: string,
	actorId: string,
	actorName: string,
	note: string,
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	if (!note.trim()) throw new Error('A reason is required to reject the request.')
	try {
		const request = await port.rejectHr(id, actorId, actorName, note)
		notify.success('hr.requestRejectedByHr')
		return request
	} catch {
		notify.error('hr.requestRejectFailed')
		throw new Error('Failed to reject request.')
	}
}

export { rejectTimeOffHr }
